import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
};

// Helper functions for common schema types
export const createArticleSchema = (article, siteUrl = 'https://fluxaraai.com') => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": article.title,
  "description": article.excerpt,
  "image": article.featuredImage,
  "author": {
    "@type": "Person",
    "name": article.author
  },
  "publisher": {
    "@type": "Organization",
    "name": "Fluxara",
    "logo": {
      "@type": "ImageObject",
      "url": `${siteUrl}/logo.png`
    }
  },
  "datePublished": article.publishedAt,
  "dateModified": article.updatedAt || article.publishedAt,
  "url": `${siteUrl}/blog/${article.slug}`
});

export const createHowToSchema = (guide, siteUrl = 'https://fluxaraai.com') => ({
  "@context": "https://schema.org",
  "@type": "HowTo",
  "name": guide.title,
  "description": guide.description,
  "image": guide.featuredImage || `${siteUrl}/default-guide.png`,
  "totalTime": guide.duration,
  "url": `${siteUrl}/guides/${guide.slug}`
});

export default StructuredData;